import Body from './components/Body';
import Header from './components/Header';
import Modal from './Modal';

export default Object.assign(Modal, {
  Header,
  Body,
});

export { default as AnimatedModal } from './AnimatedModal';
